import { clsx } from 'clsx';

import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type SVGAttrs = React.SVGAttributes<SVGElement>;

export interface FaIconLiteProps {
  icon: IconDefinition;

  className?: SVGAttrs['className'];
  style?: SVGAttrs['style'];
  color?: SVGAttrs['color'];

  beat?: boolean;
  beatFade?: boolean;
  border?: boolean;
  bounce?: boolean;
  fade?: boolean;
  fixedWidth?: boolean;
  flash?: boolean;
  flip?: true | false | 'horizontal' | 'vertical' | 'both';
  inverse?: boolean;
  listItem?: boolean;
  pull?: 'right' | 'left';
  pulse?: boolean;
  rotation?: 0 | 90 | 180 | 270;
  shake?: boolean;
  size?:
    | '2xs'
    | 'xs'
    | 'sm'
    | 'lg'
    | 'xl'
    | '2xl'
    | '1x'
    | '2x'
    | '3x'
    | '4x'
    | '5x'
    | '6x'
    | '7x'
    | '8x'
    | '9x'
    | '10x';
  spin?: boolean;
  spinPulse?: boolean;
  spinReverse?: boolean;
  swapOpacity?: boolean;
}

function classList(props: FaIconLiteProps) {
  return {
    'fa-beat': props.beat,
    'fa-beat-fade': props.beatFade,
    'fa-border': props.border,
    'fa-bounce': props.bounce,
    'fa-fade': props.fade,
    'fa-fw': props.fixedWidth,
    'fa-flash': props.flash,
    'fa-flip': props.flip === true,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both',
    'fa-inverse': props.inverse,
    'fa-li': props.listItem,
    ...(props.pull ? { [`fa-pull-${props.pull}`]: true } : {}),
    'fa-pulse': props.pulse,
    ...(props.rotation ? { [`fa-rotate-${props.rotation}`]: true } : {}),
    'fa-shake': props.shake,
    ...(props.size ? { [`fa-${props.size}`]: true } : {}),
    'fa-spin': props.spin,
    'fa-spin-pulse': props.spinPulse,
    'fa-spin-reverse': props.spinReverse,
    'fa-swap-opacity': props.swapOpacity,
  };
}

export function FaIconLite(props: FaIconLiteProps) {
  const iconTuple = props.icon.icon as [number, number, string[], string, string | string[]];
  const [width, height, , , vectorData] = iconTuple;

  if (Array.isArray(vectorData)) {
    throw new Error('duotone icon not supported');
  }

  return (
    <svg
      className={clsx(`svg-inline--fa`, props.className, classList(props))}
      style={props.style}
      focusable={false}
      role='img'
      xmlns='http://www.w3.org/2000/svg'
      viewBox={`0 0 ${width} ${height}`}
      color={props.color}
    >
      <path fill='currentColor' d={vectorData} />
    </svg>
  );
}
